import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import Button from 'ha/ui/next/Button';
import Popover from 'ha/ui/next/Popover';
import Divider from 'ha/ui/next/Divider';
import { Typography } from 'ha/ui/next/Typography';

import ArrowUpIcon from 'streamline-icons/arrow-button-up-bold.svg';
import ArrowDownIcon from 'streamline-icons/arrow-button-down-bold.svg';

import LearnItem from './LearnItem';
import { getLearnMenuLinks } from '../utils';

const useStyles = makeStyles({
  menu: {
    padding: '1rem 1.5rem',
  },
  divider: {
    padding: '1rem 0',
  },
  link: {
    paddingTop: '0.5rem',
  },
});

const LearnMenu: React.FC = () => {
  const intl = useIntl();
  const { T } = intl;
  const classnames = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleOpen = React.useCallback<
    React.MouseEventHandler<HTMLButtonElement>
  >(event => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  const menuLinks = getLearnMenuLinks(intl);

  const open = Boolean(anchorEl);
  const id = 'navbar_desktop_learn_menu';

  return (
    <React.Fragment>
      <Button
        color="inherit"
        aria-owns={open ? id : undefined}
        aria-haspopup="true"
        data-test-locator="Learn NavBar Btn"
        onClick={handleOpen}
        iconSize="small"
        endIcon={open ? <ArrowUpIcon /> : <ArrowDownIcon />}
      >
        {T('navbar_learn_button')}
      </Button>
      <Popover
        id={id}
        open={open}
        keepMounted
        disablePortal
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        PaperProps={{ elevation: 10 }}
      >
        <div className={classnames.menu} data-test-locator="Learn NavBar Menu">
          <Typography.H6>{T('navbar_tenants_title')}</Typography.H6>
          {menuLinks.tenant.map(link => (
            <div className={classnames.link} key={link.title}>
              <LearnItem {...link} />
            </div>
          ))}
          <div className={classnames.divider}>
            <Divider />
          </div>
          <Typography.H6>{T('navbar_landlords_title')}</Typography.H6>
          {menuLinks.landlord.map(link => (
            <div className={classnames.link} key={link.title}>
              <LearnItem {...link} />
            </div>
          ))}
        </div>
      </Popover>
    </React.Fragment>
  );
};

export default LearnMenu;
